import { NavLink } from "react-router-dom";
import classes from "./SideMenu.module.css";
import clsx from "clsx";
import { UserContext } from "../../contexts/AuthContext";
import { useContext } from "react";

const SideMenu = () => {
  const { logout, toggleMenuFlag, handleMenu } = useContext(UserContext);
  const handleLogout = ()=> {
    handleMenu();
    logout()
  }
  return (
    <>
    <nav className={clsx(classes.sideNav, toggleMenuFlag && classes.showNav)}>
        <ul>
          <li>
            <NavLink to={"/dashboard/all-songs"} onClick={handleMenu}>All Songs</NavLink>
          </li>
          <li>
            <NavLink to={"/dashboard/add-new-song"} onClick={handleMenu}>Add a song</NavLink>
          </li>
          <li>
              <span className={classes.logoutButton} onClick={handleLogout}>
                  Logout
              </span>
          </li>
        </ul>
      </nav>
    </> 
  );
};
export default SideMenu;
